import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';

import { storeRedirectAfterLogin } from '../../../app/auth/auth.actions';
import { authSelectors } from '../../../app/auth/auth.selectors';

export const UserOnlyRoute: FunctionComponent<RouteProps> = (props) => {
  const dispatch = useDispatch();
  const loggedUser = useSelector(authSelectors.selectLoggedUser);
  const location = useLocation();
  const intendedUrl = `${location.pathname}${location.search}`;

  useEffect(() => {
    if (!loggedUser && intendedUrl !== '/') {
      dispatch(storeRedirectAfterLogin(intendedUrl));
    }
  }, [dispatch, intendedUrl, loggedUser]);

  if (!loggedUser) {
    return <Redirect to="/login" />;
  }

  return (
    <>
      <Route {...props} />
      {/*<Timer />*/}
    </>
  );
};
